import React, { useContext, useEffect, useRef, useState } from "react";
import icon_filter from "../assets/icons/todo-sort-button.svg";
import icon_sort_active from "../assets/icons/sort_active.png";
import { TodosContext } from "../pages/ItemDetail";
const ItemFilter = () => {
  const filterRef = useRef(null);
  const { setfilterActive, filterActive, filters, sortTodo } =
    useContext(TodosContext);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleClickOutsidSort = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      isOpen && toggleDropdown();
    }
  };
  const getActiveTodo = async (item) => {
    if (filterActive.value !== item.value) {
      setfilterActive(item);
      await sortTodo(item.value);
    }
    toggleDropdown();
  };
  useEffect(() => {
    window.addEventListener("click", handleClickOutsidSort);

    return () => window.removeEventListener("click", handleClickOutsidSort);
  }, [isOpen]);
  return (
    <div ref={filterRef} className="relative">
      <button
        id="ButtonSort"
        data-cy="todo-sort-button"
        onClick={toggleDropdown}
        className="inline-flex items-center"
      >
        <img src={icon_filter} className="w-[54px] h-[54px]"></img>
      </button>
      {isOpen && (
        <div className="absolute left-0 mt-2 ">
          {filters.map((item, index) => {
            return (
              <>
                <div
                  data-cy={item.data}
                  key={index}
                  onClick={() => getActiveTodo(item)}
                  className="flex col justify-between items-center h-[52px] w-[235px] px-[20px] bg-white rounded-md shadow-2xl z-5 cursor-pointer hover:bg-gray-100"
                >
                  <div className="flex justify-start gap-3  text-sans font-700">
                    <img data-cy="sort-selection-icon" src={item.icon} />
                    <h3 data-cy="sort-selection-title">{item.label}</h3>
                  </div>
                  {filterActive.value === item.value && (
                    <img src={icon_sort_active} />
                  )}
                </div>
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ItemFilter;
